import * as actionTypes from "../../constants/actionTypes";
import { getPhoneOffers } from "../../api/phoneOffer";

const invalidatePhoneOffers = () => {
  return {
    type: actionTypes.INVALIDATE_PHONE_OFFERS_DATA
  };
};

const loadPhoneOffers = (
  clientConfig,
  dataStatus,
  filter,
  sort,
  withDetails = false
) => {
  return {
    type: actionTypes.LOAD_PHONE_OFFERS_DATA,
    promise: getPhoneOffers(clientConfig, dataStatus, filter, sort, withDetails)
  };
};

export { invalidatePhoneOffers, loadPhoneOffers };
